import { OrgsComponent } from './components/orgs/orgs.component';
import { OrgInfoComponent } from './components/org-info/org-info.component';
import { ProjectComponent } from './pages/project/project.component';
import { TestComponent } from './components/test/test.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'tests',
    component: TestComponent
  },{
    path: 'project/:project_id',
    component: ProjectComponent
  },{
    path: 'project/:project_id/test/:test',
    component: ProjectComponent
  },{
    path: 'project',
    pathMatch: 'full',
    redirectTo: 'projects'
  },{
    path: '',
    pathMatch: 'full',
    component: OrgInfoComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
